import React, { useState } from 'react';
import { useTextLanguage } from '../../hooks/useShared';
import { useModule } from '../../hooks/useTier'
import { useDescription } from '../../hooks/useProducts'
import { Back } from '../shared/simple/Back';
import { StaticMessage } from '../shared/simple/StaticMessage';
import { Title } from '../shared/simple/Title';
import { Form } from './Form';
import { ModuleContext } from '../../context/ModuleContext';
import { Row, Col, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FloatButton } from '../assistants/FloatButton';
import { ListModal } from '../assistants/List';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadset } from '@fortawesome/free-solid-svg-icons';
import { isActualRequestSuccessOrRejected, isUndefinedNull, notUndefinedNull } from '../../helpers/shared';
import { useSelector } from 'react-redux';
import IbvDialog from './ibv/IbvDialog';
import { useIbvDialog } from '../../hooks/useIbvDialog';
import { useParams } from 'react-router-dom';
import { slimTier } from '../../constants/form';

/**
 * Component module
 * @component
 * @returns
 */
export const Module = ({
  shouldShowIBV,
  setAlert
}) => {
  const { description } = useTextLanguage();
  const {
    allAssistants,
    categoriesTier,
    needAssistant,
    selectedAssistant,
    tier,
    tierFieldState
  } = useModule();
  const {
    flagRequest
  } = useDescription();
  const { t } = useTranslation();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { dataProductRequest, lastProductRequestId } = useSelector(state => state?.user);
  const {
    open,
    handleClose, 
    handleOpen ,
    requestWidgetURL
  } = useIbvDialog({setAlert})
  const { isUsed } = useSelector(state => state.base.autoLoginURL) || {}
  const params = useParams()
  const isSlimAdvanced = params?.codeTier && (params.codeTier === slimTier)
  const { isIBVVerified, isIBVRequired } = useSelector(state => state.base.ibv)
  const isIBVCompletedOrNotRequired = !isIBVRequired || isIBVVerified

  return (
    <Row>
      <Col className="p-0 text-end" xs={12}>
      {
        ((!isUsed) || !isSlimAdvanced || isIBVCompletedOrNotRequired) && <Back />
      }
      </Col>
      <Col className="p-4 pb-1 pt-1" xs={12}>
        {(notUndefinedNull(selectedAssistant)) &&
          <StaticMessage
            variant="info"
            message={ t("assistants.assignedAssistant", { name: `${
              selectedAssistant.first_name} ${selectedAssistant.last_name}` }) }
          />
        }
        {(needAssistant && isUndefinedNull(selectedAssistant)) &&
          <StaticMessage
            variant="warning"
            message={ `${t("assistants.needAssistant")}` }
          />
        }
      </Col>
      <Col className="p-4 pt-0 pb-1" xs={12}>
        <Title className="pb-1">
          { tier[description] }
        </Title>
      </Col>
      {(flagRequest) && (
        <Col className="p-3" xs={12}>
          <Alert variant={'warning'}>
            {t("common.updateDataWarningMessage")}
          </Alert>
        </Col>
      )}
      {(isActualRequestSuccessOrRejected(dataProductRequest, lastProductRequestId)) && (
        <Col className="p-3" xs={12}>
          <Alert variant={'warning'}>
            {t("common.createNewRequestWarning")}
          </Alert>
        </Col>
      )}
      {(shouldShowIBV) && (
        <Col className="p-3" xs={12}>
          <IbvDialog
            setAlert={setAlert}
            open={open}
            handleClose={handleClose}
            handleOpen={handleOpen}
            requestWidgetURL={requestWidgetURL}
          />
        </Col>
      )}
      <Col className="p-4 pt-0" xs={12}>
        <ModuleContext.Provider
          value={[ categoriesTier, tier, tierFieldState ]}
        >
          <Form 
            handleOpenIbv={handleOpen}
          />
        </ModuleContext.Provider>
      </Col>
      {(allAssistants?.length !== 0 && notUndefinedNull(
        allAssistants) && isUndefinedNull(selectedAssistant)) && (
        <FloatButton
          className="btn"
          type="submit"
          color="first"
          onClick={() => setModalIsOpen(true) }
        >
          <FontAwesomeIcon icon={ faHeadset } size="2x"/>
        </FloatButton>
      )}
      <ListModal
        modalIsOpen={ modalIsOpen }
        setModalIsOpen={ setModalIsOpen }
      />
    </Row>
  );
};